var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { attrs: { "grid-list-xs": "" } },
        [
          _c("v-layout", { attrs: { row: "", wrap: "" } }, [
            _c(
              "div",
              { attrs: { align: "left" } },
              [
                _c("v-flex", { attrs: { md12: "" } }, [
                  _c("h2", { staticClass: "h2_title" }, [
                    _vm._v("Asignar plataformas")
                  ])
                ])
              ],
              1
            )
          ]),
          _c("v-divider"),
          _c("br"),
          _c(
            "div",
            { staticStyle: { "max-height": "4px" } },
            [
              _c("v-progress-linear", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cargando,
                    expression: "cargando"
                  }
                ],
                attrs: { indeterminate: "", color: "primary" }
              })
            ],
            1
          ),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c("v-select", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  name: "plataforma",
                  items: _vm.itemsPlataforma,
                  "item-text": "nombre",
                  "item-value": "id",
                  label: "Filtrar Plataforma...",
                  "hide-details": "",
                  required: "",
                  solo: "",
                  flat: "",
                  "data-vv-name": "filtroplataforma",
                  "error-messages": _vm.errors.collect("filtroplataforma")
                },
                on: {
                  change: function($event) {
                    return _vm.changeFiltro()
                  }
                },
                model: {
                  value: _vm.modelPlataforma,
                  callback: function($$v) {
                    _vm.modelPlataforma = $$v
                  },
                  expression: "modelPlataforma"
                }
              }),
              _c("v-select", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showFiltro,
                    expression: "showFiltro"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  name: "filtro",
                  items: _vm.items,
                  "item-text": "nombre",
                  "item-value": "id",
                  label: "Filtrar...",
                  "hide-details": "",
                  required: "",
                  solo: "",
                  flat: "",
                  "data-vv-name": "filtroplataforma",
                  "error-messages": _vm.errors.collect("filtroplataforma")
                },
                on: {
                  change: function($event) {
                    return _vm.changeFiltro()
                  }
                },
                model: {
                  value: _vm.model,
                  callback: function($$v) {
                    _vm.model = $$v
                  },
                  expression: "model"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }